import { render, staticRenderFns } from "./InventoryDetails.vue?vue&type=template&id=4e11f96a&scoped=true&"
import script from "./InventoryDetails.vue?vue&type=script&lang=js&"
export * from "./InventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetails.vue?vue&type=style&index=0&id=4e11f96a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11f96a",
  null
  
)

export default component.exports